"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsRedis", {
    enumerable: true,
    get: function() {
        return JobsRedis;
    }
});
const _common = require("@nestjs/common");
const _pubsubredis = require("~/redis/pubsub-redis");
const _Jobs = require("~/interface/Jobs");
let JobsRedis = class JobsRedis {
    static async initJobs() {
        if (!_pubsubredis.PubSubRedis.initialized) {
            if (!_pubsubredis.PubSubRedis.available) {
                return;
            }
            await _pubsubredis.PubSubRedis.init();
        }
        const onMessage = async (channel, message)=>{
            try {
                if (!message) {
                    return;
                }
                const args = message.split(':');
                const command = args.shift();
                if (channel === _Jobs.InstanceTypes.WORKER) {
                    this.workerCallbacks[command] && await this.workerCallbacks[command](...args);
                } else if (channel === _Jobs.InstanceTypes.PRIMARY) {
                    this.primaryCallbacks[command] && await this.primaryCallbacks[command](...args);
                }
            } catch (error) {
                this.logger.error({
                    message: `Error processing redis pub-sub message ${message}`,
                    error: {
                        message: error == null ? void 0 : error.message,
                        stack: error == null ? void 0 : error.stack
                    }
                });
            }
        };
        if (process.env.NC_WORKER_CONTAINER === 'true') {
            await _pubsubredis.PubSubRedis.subscribe(_Jobs.InstanceTypes.WORKER, async (message)=>{
                await onMessage(_Jobs.InstanceTypes.WORKER, message);
            });
        } else {
            await _pubsubredis.PubSubRedis.subscribe(_Jobs.InstanceTypes.PRIMARY, async (message)=>{
                await onMessage(_Jobs.InstanceTypes.PRIMARY, message);
            });
        }
    }
    static async workerCount() {
        if (!_pubsubredis.PubSubRedis.initialized) {
            if (!_pubsubredis.PubSubRedis.available) {
                return;
            }
            await _pubsubredis.PubSubRedis.init();
            await this.initJobs();
        }
        return new Promise((resolve)=>{
            _pubsubredis.PubSubRedis.redisClient.publish(_Jobs.InstanceTypes.WORKER, 'count', (error, numberOfSubscribers)=>{
                if (error) {
                    this.logger.warn(error);
                    resolve(0);
                } else {
                    resolve(numberOfSubscribers);
                }
            });
        });
    }
    static async emitWorkerCommand(command, ...args) {
        const data = `${command}${args.length ? `:${args.join(':')}` : ''}`;
        await _pubsubredis.PubSubRedis.publish(_Jobs.InstanceTypes.WORKER, data);
    }
    static async emitPrimaryCommand(command, ...args) {
        const data = `${command}${args.length ? `:${args.join(':')}` : ''}`;
        await _pubsubredis.PubSubRedis.publish(_Jobs.InstanceTypes.PRIMARY, data);
    }
};
JobsRedis.logger = new _common.Logger(JobsRedis.name);
JobsRedis.available = _pubsubredis.PubSubRedis.available;
JobsRedis.primaryCallbacks = {};
JobsRedis.workerCallbacks = {};
JobsRedis.publish = _pubsubredis.PubSubRedis.publish;
JobsRedis.subscribe = _pubsubredis.PubSubRedis.subscribe;
